import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const VSTSAltLogo1Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M992 1184V560l288-52v710l-282 232-434-145v146l-308-363 736 96zm1056-971v1622l-512 213L0 1531l1536 228V0l512 213zM256 1088l-128-37V725l117-152 396-155V298l351 262-736 144v384z" />
    </svg>
  ),
  displayName: 'VSTSAltLogo1Icon',
});

export default VSTSAltLogo1Icon;
